/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createContractFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeUpdateContractCommand, type Contract, type ProblemDetails, type UpdateContractCommand } from '../../models/index.js';
// @ts-ignore
import { AffiliateConditionRequestBuilderRequestsMetadata, type AffiliateConditionRequestBuilder } from './affiliateCondition/index.js';
// @ts-ignore
import { AuditentriesRequestBuilderRequestsMetadata, type AuditentriesRequestBuilder } from './auditentries/index.js';
// @ts-ignore
import { CommissionPercentageRequestBuilderRequestsMetadata, type CommissionPercentageRequestBuilder } from './commissionPercentage/index.js';
// @ts-ignore
import { ConsumptionRequestBuilderNavigationMetadata, type ConsumptionRequestBuilder } from './consumption/index.js';
// @ts-ignore
import { ContractRequestBuilderRequestsMetadata, type ContractRequestBuilder } from './contract/index.js';
// @ts-ignore
import { MandateRequestBuilderNavigationMetadata, MandateRequestBuilderRequestsMetadata, type MandateRequestBuilder } from './mandate/index.js';
// @ts-ignore
import { OverviewsRequestBuilderRequestsMetadata, type OverviewsRequestBuilder } from './overviews/index.js';
// @ts-ignore
import { ProlongRequestBuilderRequestsMetadata, type ProlongRequestBuilder } from './prolong/index.js';
// @ts-ignore
import { SignRequestBuilderRequestsMetadata, type SignRequestBuilder } from './sign/index.js';
// @ts-ignore
import { SigningRequestBuilderNavigationMetadata, type SigningRequestBuilder } from './signing/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /contracts/{contract-id}
 */
export interface ContractItemRequestBuilder extends BaseRequestBuilder<ContractItemRequestBuilder> {
    /**
     * The affiliateCondition property
     */
    get affiliateCondition(): AffiliateConditionRequestBuilder;
    /**
     * The auditentries property
     */
    get auditentries(): AuditentriesRequestBuilder;
    /**
     * The commissionPercentage property
     */
    get commissionPercentage(): CommissionPercentageRequestBuilder;
    /**
     * The consumption property
     */
    get consumption(): ConsumptionRequestBuilder;
    /**
     * The contract property
     */
    get contract(): ContractRequestBuilder;
    /**
     * The mandate property
     */
    get mandate(): MandateRequestBuilder;
    /**
     * The overviews property
     */
    get overviews(): OverviewsRequestBuilder;
    /**
     * The prolong property
     */
    get prolong(): ProlongRequestBuilder;
    /**
     * The sign property
     */
    get sign(): SignRequestBuilder;
    /**
     * The signing property
     */
    get signing(): SigningRequestBuilder;
    /**
     * DeleteContract
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * GetContract
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Contract>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Contract | undefined>;
    /**
     * UpdateContract
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: UpdateContractCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * DeleteContract
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * GetContract
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * UpdateContract
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateContractCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ContractItemRequestBuilderUriTemplate = "{+baseurl}/contracts/{contract%2Did}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ContractItemRequestBuilderNavigationMetadata: Record<Exclude<keyof ContractItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    affiliateCondition: {
        requestsMetadata: AffiliateConditionRequestBuilderRequestsMetadata,
    },
    auditentries: {
        requestsMetadata: AuditentriesRequestBuilderRequestsMetadata,
    },
    commissionPercentage: {
        requestsMetadata: CommissionPercentageRequestBuilderRequestsMetadata,
    },
    consumption: {
        navigationMetadata: ConsumptionRequestBuilderNavigationMetadata,
    },
    contract: {
        requestsMetadata: ContractRequestBuilderRequestsMetadata,
    },
    mandate: {
        requestsMetadata: MandateRequestBuilderRequestsMetadata,
        navigationMetadata: MandateRequestBuilderNavigationMetadata,
    },
    overviews: {
        requestsMetadata: OverviewsRequestBuilderRequestsMetadata,
    },
    prolong: {
        requestsMetadata: ProlongRequestBuilderRequestsMetadata,
    },
    sign: {
        requestsMetadata: SignRequestBuilderRequestsMetadata,
    },
    signing: {
        navigationMetadata: SigningRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ContractItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: ContractItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: ContractItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createContractFromDiscriminatorValue,
    },
    put: {
        uriTemplate: ContractItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateContractCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
